export default "__VITE_ASSET__3084b1ea__"